import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
interface CountdownProps {
  className?: string;
}
export function Countdown({
  className = ''
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'Std.'
  }, {
    value: pad(minutes),
    label: 'Min.'
  }, {
    value: pad(seconds),
    label: 'Sek.'
  }];
  return <div className={className} data-id="element-70" data-mp="10dellto23bwt">
      <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-71" data-mp="10d4uu3v6t0q2">
        Das Angebot endet in
      </p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" aria-label="Verbleibende Zeit des Angebots" data-id="element-72" data-mp="y16jr6qc1zp4">
        {units.map(unit => <div key={unit.label} className="min-w-[62px] rounded-lg border border-ink-600 bg-ink-800 px-2 py-1.5" data-id="element-73" data-mp="17rhp8xpo0gy4">
            <span className="block font-display text-2xl leading-none tabular-nums text-brand" data-id="element-74" data-mp="12som9z8088c7">
              {unit.value}
            </span>
            <span className="mt-1 block text-[10px] font-semibold uppercase tracking-widest text-white/45" data-id="element-75" data-mp="a3hee9mnu6ea">
              {unit.label}
            </span>
          </div>)}
      </div>
    </div>;
}